// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"highlighted-block"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 20L21 20M3 15L21 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 4L3 4L3 10L16 10V4Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 4L3 4L3 10L16 10V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HighlightedBlockIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'highlighted-block',
    ref,
    icon: element,
  },
));

HighlightedBlockIcon.displayName = 'HighlightedBlockIcon';

export default HighlightedBlockIcon;
